<!-- src/components/Projects/ProjectTopCard.vue-->
<template>
  <!-- Single Card View using Vuetify -->
  <v-card
    class="v-responsive"
    max-width="450px"
    elevation="15"
    :color="project.publish_website_flag ? 'green' : 'grey'"
  >
    <br />
    <div
      class="img-circle"
      :style="{'background-image': 'url(' + `${getImage}` + ')'}"
    ></div>
    <v-card-title>
      <h4 class="white--text text-wrap text-break">
        {{ project.project_name }}
      </h4></v-card-title
    >
    <v-card style="padding: 10px" tile>
      <v-card-title>Current Goals</v-card-title>
      <v-list>
        <transition-group>
          <v-card
            style="margin: 10px; padding: 10px"
            v-for="element in getGoalList"
            :key="element.id"
          >
            <v-row
              ><v-col class="col-1"><v-icon>mdi-circle</v-icon></v-col
              ><v-col><p v-html="convertTextToLink(element.name)"></p></v-col
            ></v-row>
          </v-card>
        </transition-group>
      </v-list>
    </v-card>
    <v-card-actions class="wrap_circles">
      <v-btn color="blue" class="ml-2 mt-1"
        >Priority:
        {{ project.project_priority }}
      </v-btn>
      <v-btn class="green mt-1">status: {{ project.project_status }}</v-btn>
      <v-btn class="green mt-1" @click="gotoReportView(project)"
        >View Report</v-btn
      >
      <b-button
        v-if="project.publish_website_flag"
        variant="success"
        class="publishTag"
        style="font-size: 11px"
        v-b-tooltip.hover
        title="This Card is Published click to Un publish"
        v-on:click="togglePublish"
        >Published
      </b-button>
      <b-button
        v-else
        v-b-tooltip.hover
        title="This Card is NotPublished click to Publish"
        v-on:click="togglePublish"
        variant="danger"
        class="publishTag"
        style="font-size: 11px"
        >Not Published
      </b-button>
      <br />
    </v-card-actions>
    <v-card-actions class="wrap_circles">
      <v-btn class="ml-2 mt-1" v-on:click="goToInnerCard">InnerCard View</v-btn>
      <v-btn class="mt-1" v-on:click="goToProjectDetail" v-b-modal="editModalId"
        >Edit Card</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn icon @click="showDetail">
        <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>
        <v-card-text
          ><b-jumbotron
            >Description:
            {{ project.project_description }}
          </b-jumbotron></v-card-text
        >
        <project-top-card-targets
          :targets="this.project.targets"
          :projectId="this.project.id"
        />
        <v-card-text
          >Version : {{ project.project_latest_version }}</v-card-text
        >
        <v-card-text>Project Links</v-card-text>
        <!-- TODO: this looks like it could be replaced with a v-for? -->
        <v-card-actions class="wrap_circles">
          <v-btn
            v-if="
              project.working_software_link_ios !== null &&
              project.working_software_link_ios !== ''
            "
            class="fab-btn ml-2"
            color="black"
            target="_blank"
            fab
            :href="project.working_software_link_ios"
            >IOS</v-btn
          >
          <v-btn
            v-if="
              project.working_software_link_web !== null &&
              project.working_software_link_web !== ''
            "
            class="fab-btn"
            color="blue"
            target="_blank"
            fab
            :href="project.working_software_link_web"
            >WEB</v-btn
          >
          <v-btn
            v-if="
              project.working_software_link_android !== null &&
              project.working_software_link_android !== ''
            "
            class="fab-btn"
            color="grey"
            target="_blank"
            fab
            :href="project.working_software_link_android"
            >ANDROID</v-btn
          >
          <v-btn
            v-if="
              project.source_control_link !== null &&
              project.source_control_link !== ''
            "
            class="fab-btn"
            color="brown"
            target="_blank"
            fab
            :href="project.source_control_link"
            >Source</v-btn
          >
          <v-btn
            v-if="
              project.source_control_link1 !== null &&
              project.source_control_link1 !== ''
            "
            class="fab-btn"
            color="brown"
            target="_blank"
            fab
            :href="project.source_control_link1"
            >Source 2</v-btn
          >
          <v-btn
            v-if="
              project.source_control_link2 !== null &&
              project.source_control_link2 !== ''
            "
            class="fab-btn"
            color="brown"
            target="_blank"
            :href="project.source_control_link2"
            fab
            >Source 3</v-btn
          >
          <v-btn
            v-if="
              project.project_management_link !== null &&
              project.project_management_link !== ''
            "
            class="fab-btn"
            color="purple"
            target="_blank"
            fab
            :href="project.project_management_link"
            >PM</v-btn
          >
          <v-btn
            v-if="
              project.working_software_link_xd !== null &&
              project.working_software_link_xd !== ''
            "
            class="fab-btn"
            color="purple"
            target="_blank"
            fab
            :href="project.working_software_link_xd"
            >XD</v-btn
          >
          <v-btn
            v-if="
              project.document_and_other !== null &&
              project.document_and_other !== ''
            "
            class="fab-btn"
            color="purple"
            target="_blank"
            fab
            :href="project.document_and_other"
            >Doc</v-btn
          >
        </v-card-actions>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ProjectTopCardTargets from "./ProjectTargets/ProjectTopCardTargets.vue";

export default {
  name: "ProjectTopCard",
  components: {
    ProjectTopCardTargets,
  },
  props: ["id", "project", "modalId", "editModalId", "publishFlag"],
  data() {
    return {
      goalList: [],
      display: {},
      show: false,
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    getImage() {
      let img = this.project.project_image_url;
      if (
        this.project.project_image_url === "" ||
        this.project.project_image_url === null
      ) {
        img = require("@/assets/image/NekologicSquare.png");
      }
      return img;
    },
    getGoalList() {
      // TODO: I think this should be replaced with an array
      return [
        {
          id: 1,
          name: this.project.project_current_goal_one,
        },
        {
          id: 2,
          name: this.project.project_current_goal_two,
        },
        {
          id: 3,
          name: this.project.project_current_goal_three,
        },
      ];
    },
  },
  methods: {
    ...mapActions(["toggleProjectPublishFlag", "fetchProjectList"]),
    goToProjectDetail() {
      const project = this.project;
      this.$emit("child-to-parent-projects", project);
    },
    goToInnerCard() {
      this.$router.push({
        name: "InnerCard",
        query: {
          project_id: this.project.id,
        },
      });
    },
    showDetail() {
      this.show = !this.show;
    },
    togglePublish() {
      const projectId = this.project.id;
      const newPublishState = !this.project.publish_website_flag;
      this.toggleProjectPublishFlag({projectId, newPublishState});
    },
    convertTextToLink(text) {
      if (text === null) return "";
      let urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function (url) {
        return `<a href="${url}">${url}</a>`;
      });
    },
    gotoReportView(project) {
      this.$router.push({
        name: "Report",
        query: {id: project.id, name: project.project_name},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  cursor: pointer;
}
.card {
  width: 15rem;
  flex: none;
  position: relative;
}
.publishTag {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 0.8rem;
  padding: 0.4rem 0.75rem;
}
.imgCard {
  margin: 0;
  max-width: 15rem;
  height: 150px;
  object-fit: cover;
}
.fab-btn {
  max-width: 50px;
  max-height: 50px;
  margin: 0px 0px 10px 0px;
  font-size: 9px;
  color: whitesmoke;
  font-weight: bold;
}
.img-circle {
  border-radius: 50%;
  border: solid 10px #85d4dd;
  margin: auto;
  background-repeat: no-repeat;
  background-position-x: center;
  background-size: cover;
  height: 0;
  width: 95%;
  padding-bottom: 90%;
}
.card-shadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.wrap_circles {
  display: flex;
  flex-wrap: wrap;
}
</style>
